import { Component, ElementRef, Input, OnChanges, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';

import { DataAccessExhibitorsPageFacade, DataAccessFairsFacade } from '@planone/bau365/data-access-fair-data';
import { WatchlistPageContext } from '@planone/bau365/data-access-user';
import { ShareFacade } from '@planone/bau365/feature-tracking';
import { EntityType, ExhibitorCardData } from '@planone/bau365/util-fair-data';
import { DataAccessTogglesFacade } from '@planone/shared/data-access-feature-flags';
import { ModalBottomsheetHelper, ModalBottomsheetType, ShareButtonsHelper } from '@planone/shared/ui-elements';
import { localizedMeta } from '@planone/shared/util-meta';
import { ImageFileTypes } from '@planone/shared/util-pipelines';
import { map, Observable } from 'rxjs';

@Component({
  selector: 'bau365-exhibitor-card',
  templateUrl: './exhibitor-card.component.html',
  styleUrls: ['./exhibitor-card.component.scss'],
})
export class ExhibitorCardComponent implements OnChanges {
  @Input()
  item: ExhibitorCardData | undefined;

  @Input()
  fairId: string | undefined;

  @Input()
  size: string | undefined | null;

  @Input()
  pageContext: WatchlistPageContext | undefined;

  @Input()
  insightsId: string | undefined | null;

  @Input()
  markAsNew: boolean | undefined;

  url: string | undefined;
  startDateFormat: string | undefined;
  EntityType = EntityType;
  emailSubject = localizedMeta['shareEmailSubject'];
  emailBody = localizedMeta['shareEmailBody'];
  ImageFileTypes = ImageFileTypes;

  hallPlanToggle$: Observable<boolean | undefined>;
  hallplanActiveList$: Observable<string[]>;

  @ViewChild('title') title?: ElementRef;
  @ViewChild('shareButtonsTitle') public shareButtonsTitle: TemplateRef<never> | null | undefined;
  @ViewChild('shareButtons') public shareButtons: TemplateRef<never> | null | undefined;

  constructor(
    togglesFacade: DataAccessTogglesFacade,
    fairsFacade: DataAccessFairsFacade,
    private shareButtonsHelper: ShareButtonsHelper,
    private modalBottomsheetHelper: ModalBottomsheetHelper,
    private ExhibitorsPageFacade: DataAccessExhibitorsPageFacade,
    private trackingShareFacade: ShareFacade
  ) {
    this.hallPlanToggle$ = togglesFacade.flag('kill-hall-plan').pipe(map((hallplanDisabled) => !hallplanDisabled));
    this.hallplanActiveList$ = fairsFacade.fairsConfig$.pipe(
      map((fairsConfig) =>
        Object.keys(fairsConfig.fairs)
          .map((fairId) => ({ ...fairsConfig.fairs[fairId], id: fairId }))
          .filter((fair) => fair.hallplan)
          .map((fair) => fair.id)
      )
    );
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['item']) {
      const baseUrl = `fairs/${this.fairId}/exhibitors/`;
      this.url = this.shareButtonsHelper.buildShareUrlFromPath(
        baseUrl + encodeURIComponent(changes['item'].currentValue.id)
      );
      this.emailBody += $localize`:@@exhibitorCard-emailShare-entityType:Aussteller ${this.item?.name}`;
    }
    if (changes['size']) {
      if (changes['size'].currentValue === 'phone') {
        this.startDateFormat = 'MM.dd.yy hh:mm';
      } else {
        this.startDateFormat = 'MM.dd.yyyy hh:mm';
      }
    }
  }

  openShareButtonDialog(event: Event) {
    event.preventDefault();
    event.stopPropagation();

    if (this.item && this.fairId && this.pageContext) {
      this.ExhibitorsPageFacade.shareDialogOpened('EVENT', this.pageContext, this.fairId, this.item);
      this.trackingShareFacade.open({
        entityType: 'EXHIBITOR',
        pageType: this.pageContext,
        context: this.fairId,
        entities: {
          exhibitor: this.item,
        },
      });
    }

    this.modalBottomsheetHelper.openDialog(
      ModalBottomsheetType.share,
      this.shareButtonsTitle,
      this.shareButtons,
      this.size
    );
  }

  shareButtonClick(network: string) {
    if (this.item && this.fairId && this.pageContext) {
      this.ExhibitorsPageFacade.shareButtonClicked(network, this.item, this.fairId, this.pageContext, 'EXHIBITOR');
      this.trackingShareFacade.click({
        entityType: 'EXHIBITOR',
        pageType: this.pageContext,
        context: this.fairId,
        network: network,
        entities: {
          exhibitor: this.item,
        },
      });
    }
  }
}
